import React from 'react';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import RoleService from '../Services/roleService';

class FigmaButton extends React.Component {
  static defaultProps = {
    className: '',
    value: 'default label',
    url: 'https://www.bareinternational.com/',
    iconName: 'fa-solid fa-circle',
    disabled: false,
    label: 'Default buttonlabel',
    type: ButtonTypeEnum.NormalNormal,
    color: ButtonColorsEnum.Primary,
    iconPosition: IconPositionEnum.None,
    tooltip: '',
    roleKey: '',
    submit: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const size = this.props.type ? this.props.type.toLowerCase() : this.props.label ? 'normalnormal' : 'normalicononly';
    const disabled = !(
      !this.props.disabled &&
      (!this.props.roleKey ||
        (this.props.roleKey && RoleService.CheckUserPermission('ButtonRowButton', this.props.roleKey)))
    );

    const className = `figmabutton ${disabled ? 'figmabutton_disabled' : ''} ${this.props.color} ${size} ${
      this.props.className ? this.props.className : ''
    } `;

    const label = this.props.type.includes('icononly') ? '' : this.props.label;
    return (
      <button
        className={className}
        onClick={disabled ? () => {} : this.props.onClick}
        multiline='true'
        type={this.props.submit ? 'submit' : 'button'}
        data-tip={'tooltip'}
        data-placement='top'
        // title={this.props.disabled?"":this.props.tooltip}
        title={this.props.tooltip}
      >
        {(this.props.iconPosition === IconPositionEnum.Left || !this.props.iconPosition) && (
          <i className={`${this.props.iconName} mr-1`} />
        )}
        {label}
        {this.props.iconPosition === IconPositionEnum.Right && <i className={`${this.props.iconName} ml-1`} />}
        {this.props.iconPosition === IconPositionEnum.Center && <i className={this.props.iconName} />}
      </button>
    );
  }
}

export default FigmaButton;
